import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

SwiperCore.use([Navigation]);

interface Props {
  title: string;
  list: any[];
}

function SlideItems({ title, list }: Props) {
  // SET ANIMATION
  const { ref, inView } = useInView();

  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    if (inView === true) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  }, [inView]);

  const moveUp = `${scroll === false ? 'moveup--hidden' : 'moveup'}`;
  const fadein = `${scroll === false ? 'fadein--hidden' : 'fadein'}`;


  const renderSlide = () => {
    return list.map(item => {
      return (
        <SwiperSlide key={item.title}>
          <div className="img-box">
            <img src={item.img} alt="" />
            <div className="text-box">
              <div className="text-box-title">
                <p>{item.title}</p>
              </div>
              <div className="text-box-desc">{item.description}</div>
            </div>
          </div>
        </SwiperSlide>
      );
    });
  };

  if (list.length > 0) {
    return (
      <>
        <div ref={ref} className="slide">
          <div className="slide-container">
            <div className={`${moveUp} slide-items`}>
              <div className={`${fadein} title`}>{title}</div>
              <div className="slider">
                <Swiper
                  slidesPerView={'auto'}
                  spaceBetween={30}
                  slidesPerGroup={1}
                  navigation={true}
                  className={`mySwiper ${fadein}`}>
                  {renderSlide()}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return null;
  }
}

export default SlideItems;
